<template>
  <!-- accordion like settings-->

  <v-card class="ma-5">

  </v-card>
</template>

<script setup>

import { onMounted } from "vue";

onMounted(() => {
  if (
      confirm("reset totale, sei sicuro di voler applicare il reset totale", 
      "reset totale",
      "si",
      "no")
    ) { 
      console.log("reset totale");
    }
  else {
    console.log("reset totale annullato");
  }

});
</script>
